import { motion } from "framer-motion"
import HeroSection from "@/components/start/HeroSection"
import AboutUs from "@/components/start/AboutUs"
import FeaturedLawFirms from "@/components/start/FeaturedLawFirms"
import Services from "@/components/start/Services"
import Testimonials from "@/components/start/Testimonials"
import CallToAction from "@/components/start/CallToAction"
import Benefits from "@/components/start/Benefits"
import ContactForm from "@/components/start/ContactForm"
import Footer from "@/components/start/Footer";

function Home() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <HeroSection />
      <AboutUs />
      <FeaturedLawFirms />
      <div className="container mx-auto px-4  bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        <Services />
        <Testimonials />
      </div>
      <CallToAction />
      <Benefits />
      <ContactForm />
      <Footer />
    </motion.div>
  )
}

export default Home

